import { Action } from "../../../action";
import { DefaultApi } from "../../../api";
import { getCatchError } from "../../../getCatchError";
import { urls } from "../../../urls";

const setGetCashiersProfile = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_LIST_CATEGORIES
            });
            if (data.status === 'success') {
                dispatch(Action.SetGetCashiersProfileAction({
                    data: data.data,
                    countPage: data.countPage
                }));
            }
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetCashiersProfile as SetGetCashiersProfile
}